import { FormGroup } from '@angular/forms';

/**
 * Custom validator to check that two fields match.
 * @param controlName Name of the origin control.
 * @param matchingControlName Name of the confirmation control.
 */
export function mustMatch(controlName: string, matchingControlName: string): ((formGroup: FormGroup) => void) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
